export enum UserActionTypeCompleted {
  CalendarAllRestoreCompleted = 'CalendarAllRestoreCompleted',
  CalendarEventsRestoreCompleted = 'CalendarEventsRestoreCompleted',
  CalendarGroupsRestoreCompleted = 'CalendarGroupsRestoreCompleted',
  CalendarsRestoreCompleted = 'CalendarsRestoreCompleted',
  ContactGroupsRestoreCompleted = 'ContactGroupsRestoreCompleted',
  ContactsAllRestoreCompleted = 'ContactsAllRestoreCompleted',
  ContactsRestoreCompleted = 'ContactsRestoreCompleted',
  DriveItemsRestoreCompleted = 'DriveItemsRestoreCompleted',
  MailAllRestoreCompleted = 'MailAllRestoreCompleted',
  MailMessagesRestoreCompleted = 'MailMessagesRestoreCompleted',
  MailFolderRestoreCompleted = 'MailFolderRestoreCompleted',
  SharedDrivesRestoreCompleted = 'SharedDrivesRestoreCompleted',
  SharePointRestoreCompleted = 'SharePointRestoreCompleted'
}
